/**
 * Global particle reduction flag.
 * When true, particle effects are reduced or skipped to avoid frame drops
 * during win speed-up where 50+ emitters would otherwise be created simultaneously.
 */
export let reducedParticles = false;

export function setReducedParticles(value: boolean): void {
  reducedParticles = value;
}

/**
 * Global FX/easing toggle.
 * When true, all tweens/animations should complete instantly and particles are fully skipped.
 * Used for testing bot behavior without waiting for animations.
 */
export let fxDisabled = false;

export function setFxDisabled(value: boolean): void {
  fxDisabled = value;
}
